import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import App from './App';
import Authentication from './components/Authentication';

const AuthWrapper = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setIsLoading(false);
      if (user) {
        setShowAuthModal(false); // Close auth modal when user signs in
      }
    });

    return () => unsubscribe();
  }, []);

  const handleAuthenticated = () => {
    // The user state will be updated by the onAuthStateChanged listener
    // Close the auth modal
    setShowAuthModal(false);
  };

  const handleSignOut = () => {
    // The user state will be updated by the onAuthStateChanged listener
    // No need to do anything here
  };

  const handleShowAuth = () => {
    setShowAuthModal(true);
  };

  const handleCloseAuth = () => {
    setShowAuthModal(false);
  };

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Always show the main app */}
      <App 
        user={user} 
        onSignOut={handleSignOut}
        onShowAuth={handleShowAuth}
      />
      
      {/* Show authentication modal when needed */}
      {showAuthModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="relative max-w-md w-full mx-4">
            <button
              onClick={handleCloseAuth}
              className="absolute top-4 right-4 z-10 text-gray-400 hover:text-gray-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <Authentication onAuthenticated={handleAuthenticated} />
          </div>
        </div>
      )}
    </>
  );
};

export default AuthWrapper; 